module.exports = __webpack_public_path__ + "img/TheRiseFrameworkColored.c53d097c.jpg";